import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WSelect = /*#__PURE__*/function (_Vue) {
  function WSelect() {
    var _this;
    _classCallCheck(this, WSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WSelect, [].concat(args));
    _defineProperty(_this, "name", void 0);
    _defineProperty(_this, "options", void 0);
    _defineProperty(_this, "size", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "fieldLabel", void 0);
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "currentValue", null);
    return _this;
  }
  _inherits(WSelect, _Vue);
  return _createClass(WSelect, [{
    key: "mounted",
    value: function mounted() {
      this.currentValue = this.value;
    }
  }, {
    key: "onInputChanges",
    value: function onInputChanges() {
      if (!this.disabled) {
        this.$emit("change", this.currentValue);
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], WSelect.prototype, "name", void 0);
__decorate([Prop()], WSelect.prototype, "options", void 0);
__decorate([Prop({
  default: 'default'
})], WSelect.prototype, "size", void 0);
__decorate([Prop({
  default: 'auto'
})], WSelect.prototype, "width", void 0);
__decorate([Prop()], WSelect.prototype, "fieldLabel", void 0);
__decorate([Prop()], WSelect.prototype, "placeholder", void 0);
__decorate([Prop({
  default: false
})], WSelect.prototype, "disabled", void 0);
__decorate([Prop()], WSelect.prototype, "value", void 0);
WSelect = __decorate([Options({
  watch: {
    value: function value() {
      this.currentValue = this.value;
    }
  }
})], WSelect);
export default WSelect;